import Results from '../ui/layouts/Results';

function Root() {
  return <Results />;
}

export default Root;
